import { useQuery } from "@tanstack/react-query";
import { BUSINESS_BCP_VALUE, BUSINESS_CSKH_VALUE } from "constant";
import { ReportBusinessApi } from "service/api/report-business.api";
import { QUERY_KEYS } from "service/constant/query-keys";
import { downloadFileByUrl } from "ultis/common";

export const useGetReportBusiness = (params, options) => {
  const newParams = { ...params };
  // params include: from, to
  // delete typeReport
  delete newParams.typeReport;

  return useQuery({
    queryKey: [QUERY_KEYS.REPORT_BUSINESS, params],
    queryFn: async () => {
      let res;
      if (params.typeReport === BUSINESS_CSKH_VALUE) {
        res = await ReportBusinessApi.getReportBusinessCSKH(newParams);
      } else if (params.typeReport === BUSINESS_BCP_VALUE) {
        res = await ReportBusinessApi.getReportBusinessBCP(newParams);
      }

      return res.data?.data;
    },
    ...options,
  });
};

export const useExportLogReportBusiness = (params, options) => {
  const newParams = { ...params, isExportExel: true };
  // params include: from, to
  // delete typeReport
  delete newParams.typeReport;

  return useQuery({
    queryKey: [QUERY_KEYS.REPORT_BUSINESS, newParams],
    queryFn: async () => {
      let res;
      if (params.typeReport === BUSINESS_CSKH_VALUE) {
        res = await ReportBusinessApi.getReportBusinessCSKH(newParams);
      } else if (params.typeReport === BUSINESS_BCP_VALUE) {
        res = await ReportBusinessApi.getReportBusinessBCP(newParams);
      }
      const fileUrl = res.data?.data?.url;
      if (fileUrl) {
        downloadFileByUrl(fileUrl);
      }
    },
    enabled: false,
    ...options,
  });
};
